import { i18n } from "@/plugins/i18n";
import { TableFieldType, TableHeader } from "helix-vue-components";

export const PermissionRoleTableMetadata: TableHeader[] = [
  {
    value: "name",
    label: String(i18n.t("name")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: true,
    descending: true
  },
  {
    value: "desc",
    label: String(i18n.t("description")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: true,
    descending: true
  },
  {
    value: "users",
    label: String(i18n.t("users")),
    fieldComponent: TableFieldType.avatarGroup,
    class: "tdt__headers__fieldLong",
    sortable: false
  }
];
